import React from "react";
import "../styles/TopSection.css";
import LatestUpdates from "./LatestUpdates";
import ProfileImages from "./ProfileImages";
import InfoGrid from "./InfoGrid"; // New component for Experience, Role, See Also

const TopSection = () => {
  return (
    <div className="top-section">
      <ProfileImages />
      <LatestUpdates />
      <InfoGrid /> {/* New component to display three rows */}
    </div>
  );
};

export default TopSection;
